import { env } from "../config/env"
import { scanSources } from "../constants"

// Mirrors eventQrStatuses in the API, which derives them from IsActive /
// StartsAt / ExpiresAt on every read.
export const eventQrStatuses = Object.freeze({
  INACTIVE: "inactive",
  SCHEDULED: "scheduled",
  LIVE: "live",
  ENDED: "ended",
})

export const eventQrStatusStyles = Object.freeze({
  [eventQrStatuses.LIVE]: {
    label: "Live",
    className: "bg-green-100 text-green-700",
  },
  [eventQrStatuses.SCHEDULED]: {
    label: "Scheduled",
    className: "bg-blue-100 text-blue-700",
  },
  [eventQrStatuses.ENDED]: {
    label: "Ended",
    className: "bg-gray-100 text-gray-600",
  },
  [eventQrStatuses.INACTIVE]: {
    label: "Off",
    className: "bg-amber-100 text-amber-700",
  },
})

/*
  The link encoded in an event's QR. Built from PublicUuid alone, which never
  changes, so the QR drawn today is the same image that was printed — editing
  the event's name, dates or videos never breaks it.

  Uses the configured PROD site rather than the admin's own origin, so a QR
  downloaded from a staging admin still sends attendees to PROD.
*/
export const getEventQrLink = (publicUuid) => {
  const site = (
    env.REACT_APP_PUBLIC_SITE_URL || window.location.origin
  ).replace(/\/+$/, "")
  return `${site}/educational-videos/event/${publicUuid}`
}

// Admin preview: same page, nothing tracked. Opens on the admin's own site so
// staging admins preview staging data.
export const getEventQrPreviewLink = (publicUuid) =>
  `${window.location.origin}/educational-videos/event/${publicUuid}?source=${scanSources.PREVIEW}`
